import React, { useContext } from 'react'
import classes from './FAQ.module.scss'
import Accordion from './Accordion/Accordion'
import {LanguageContext } from '../../containers/Language';

const FAQ = () => {

  const { dictionary } = useContext(LanguageContext);

  const content = [
      {
        title: dictionary.FAQ_1_QU,
        text: dictionary.FAQ_1_ANS
      },

      {
        title: dictionary.FAQ_2_QU,
        text: dictionary.FAQ_2_ANS
      },

      {
        title: dictionary.FAQ_3_QU,
        text: dictionary.FAQ_3_ANS
      },

      {
        title: dictionary.FAQ_4_QU,
        text: dictionary.FAQ_4_ANS
      },

      {
        title: dictionary.FAQ_5_QU,
        text: dictionary.FAQ_5_ANS
      },

      {
        title: dictionary.FAQ_6_QU,
        text: dictionary.FAQ_6_ANS
      },

      {
        title: dictionary.FAQ_7_QU,
        text: dictionary.FAQ_7_ANS
      }
  ]

  const faqs = content.map((data, id) => {
      return <Accordion id={id} text={data.text} title={data.title} />
  });

  return (
      <div className={classes.faq}>
          <h3 dangerouslySetInnerHTML={{__html: dictionary.FAQ}} className={`text-center ${classes.title}`}></h3>
      
          <div className={classes.faqInner}>
            <div className="accordion" id="faq">
                {faqs}
            </div>
          </div>
      </div>
  )
}

export default FAQ
